import {globalCatch} from "../../../_services/global-catch";
import {contractManagementApi, documentApi, precontractMetaApi, protoMetaApi} from "../../../_services/fct-service";
import {SET_DOCUMENTS_META, SET_PRECONTRACTS_META} from "./constants";
import {PrecontractDocumentsApi} from "../../../_api/fct/src";

export const setPrecontractsMeta = val => ({type: SET_PRECONTRACTS_META, payload: { proto_meta: val }});
export const setDocumentsMeta = val => ({type: SET_DOCUMENTS_META, payload: { documents_meta: val }});

export const fetchProtoMeta = (precontractId) => globalCatch.catch(async (dispatch) => {
  const protoMeta = await (await protoMetaApi()).apiV1MyaccountProtoDocumentMetaPrecontractIdGet(precontractId);
  dispatch(setPrecontractsMeta(protoMeta))
});

export const fetchStatusAccountPrecontract = async (precontractId) => {
    return await (await contractManagementApi()).apiV1MyaccountSignprecontractPrecontractIdPost(precontractId);
};

export const fetchDocumentsMeta = (precontractId) => globalCatch.catch(async (dispatch) => {
  const documents = await (await precontractMetaApi()).apiV1MyaccountProtoDocumentsPrecontractIdGet(precontractId);
  dispatch(setDocumentsMeta(documents));
});

export const postProtoMeta = async (precontractID, protoMetaData) => {
  return await (await protoMetaApi()).apiV1MyaccountProtoDocumentMetaPrecontractIdPost(precontractID, protoMetaData);
};

export const postProtoDocument = async (precontractId, file, type) => {
  return await (await precontractMetaApi()).apiV1MyaccountProtoDocumentPrecontractIdPost(precontractId, {file, fileName: file.name, documentType: type});
}

export const deleteProtoDocument = async (documentId) => {
  return await (await precontractMetaApi()).apiV1MyaccountProtoDocumentDeletePrecontractIdDelete(documentId);
}

export const downloadProtoFile = async (documentId, filename) => {
  new PrecontractDocumentsApi().apiV1MyaccountProtoDocumentPrecontractIdGet(documentId)
      .then(async (res) => {
        const base64Response = await fetch(`data:${res.type};base64,${res.data}`);
        const blob = await base64Response.blob();
        const input = document.createElement("a");
        input.href = URL.createObjectURL(blob);
        input.setAttribute("download", filename.split('.')[0]);
        input.click();
      });
}

export const allDocumentsDeliveryConfirmation = async (precontractId) => {
  return await (await precontractMetaApi()).apiV1MyaccountProtoDocumentsPrecontractIdPut(precontractId);
}

